import { PriceType, ProductType } from '@wix/ambassador-forms-v4-form/types';
import { generateUUID } from '@wix/form-schema';
export function toProductValue(product, value) {
  return {
    productId: product.id,
    price: value,
    quantity: 1
  };
}
export function aDynamicPriceProduct() {
  return {
    id: generateUUID(),
    priceType: PriceType.DYNAMIC_PRICE,
    productType: ProductType.DIGITAL,
    quantityLimit: {
      minimum: 1,
      maximum: 1
    },
    dynamicPriceOptions: {
      minPrice: '0'
    }
  };
}
//# sourceMappingURL=payment-input-field-utils.js.map